import { ITicketType } from "./ITicketType";

export const ROLES = {
  ROLE_USER: 'User',
  ROLE_AGENT: 'Agent',
  ROLE_VENDOR: 'Vendor',
  ROLE_ADMIN: 'Admin',
};

export type TRole = keyof typeof ROLES;

export interface IRole {
  role: TRole,
  notes: string,
  authority: string,
}

export interface IGroupedRole {
  id: number,
  name: string,
  created: string | null,
  deleted: boolean,
  description: string | null,
  ticketTypes: ITicketType[]

}

export interface INewRole {
  id: number | undefined;
  name: string,
  description: string,
  ticketTypes: string
  systemRole: IRoleGoup
}

export const ASSIGNABLE_ROLES: Partial<keyof typeof ROLES>[] = [
  'ROLE_AGENT',
  'ROLE_VENDOR',
  'ROLE_ADMIN',
];

export type IRoleGoup = 'agent' | 'vendor';
